export default __webpack_public_path__ + "static/char-s-sp02-chs-242d745fe21c76ce12462f3d32d6bd0a.webp";